/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { WidgetTypeFromJSON, WidgetTypeToJSON } from './';
export function CreateWidgetDataFromJSON(json) {
    return CreateWidgetDataFromJSONTyped(json, false);
}
export function CreateWidgetDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        title: json['title'],
        type: !exists(json, 'type') ? undefined : WidgetTypeFromJSON(json['type']),
        config: !exists(json, 'config') ? undefined : json['config'],
        GridId: json['GridId'],
    };
}
export function CreateWidgetDataToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        title: value.title,
        type: WidgetTypeToJSON(value.type),
        config: value.config,
        GridId: value.GridId,
    };
}
